import { headerClass, headerType, photoPosition, photoSide } from '@/types/uiPhoto.types'
import type { IBoxFields } from '@/types/contentful'

export default function () {
  const { t } = useI18n()
  
  const uiBoxes = () => ([
    {
      title: t('wellbeingSale.assistant.box1Title'),
      description: t('wellbeingSale.assistant.box1Paragraph'),
    },
    {
      title: t('wellbeingSale.assistant.box2Title'),
      description: t('wellbeingSale.assistant.box2Paragraph'),
    },
    {
      title: t('wellbeingSale.assistant.box3Title'),
      description: t('wellbeingSale.assistant.box3Paragraph'),
    },
    {
      title: t('wellbeingSale.assistant.box4Title'),
      description: t('wellbeingSale.assistant.box4Paragraph'),
    },
    {
      title: t('wellbeingSale.assistant.box5Title'),
      description: t('wellbeingSale.assistant.box5Paragraph'),
    },
    {
      title: t('wellbeingSale.assistant.box6Title'),
      description: t('wellbeingSale.assistant.box6Paragraph'),
    },
  ]) as IBoxFields[]

  const uiPhotoData = () => {
    return {
      desktopHeaderClass: headerClass.H5,
      mobileHeaderClass: headerClass.H8,
      headingType: headerType.H3,
      headerTitle: t('wellbeingSale.assistant.title'),
      desktopPhotoPosition: photoPosition.LEFT,
      photoDesktop: [{
        url: t('wellbeingSale.assistant.photo'),
        public_id: '',
      }],
      photoMobile: [{
        url: t('wellbeingSale.assistant.photo'),
        public_id: '',
      }],
      photoSide: photoSide.RIGHT,
      descriptionSize: 'small',
      description: {
        content: [
          {
            nodeType: 'paragraph',
            content: [
              {
                value: t('wellbeingSale.assistant.paragraph1'),
              },
            ],
          },
          {
            nodeType: 'paragraph',
            content: [
              {
                value: t('wellbeingSale.assistant.paragraph2'),
              },
            ],
          },
        ],
      },
    }
  }

  return {
    uiPhotoData,
    uiBoxes,
  }
}
